/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertAdapter, CommonDropdown, FormInput, ICommonDropdownOption } from 'pg-ui-library';
import { ChoiceContainer, TextChoice } from 'src/components/distribution-modal/styles';
import { dropdownOptions } from 'src/modules/benefits/components/qualifying-life-event-details';
import { useQuery, useMutation } from '@tanstack/react-query';
import PaymentsService from 'src/services/payments.service';
import {
  Container,
  FormInputContainer,
  FormRow,
  FormTitle,
  WorkLocationFormContainer,
  SeparatorLineStraight,
  FormTitleItem,
  FormInputLabel,
} from './styles';
import { PersonalInfoForm } from '../..';

const DistributionForm: React.FC<PersonalInfoForm> = ({ personalInfo }) => {
  const [mailMethod, setMailMethod] = useState<string>('ESS'); // Default to 'ESS'
  const { t } = useTranslation();
  const { isLoading, data: distribution } = useQuery({
    queryKey: ['payments/distribution'],
    queryFn: () => PaymentsService.getDistributionMethod(),
    enabled: true,
  });

  const dropdownOptions: ICommonDropdownOption[] = [
    {
      key: 'ESS',
      label: 'I consent to review W-2s electronically in this portal',
      value: 'ESS',
    },
    {
      key: 'user',
      label: 'I require my W2 to be mailed to me',
      value: 'user',
    },
  ];

  useEffect(() => {
    if (distribution?.data?.method) {
      const { method } = distribution.data;
      if (method === 'user') {
        setMailMethod('user');
      } else {
        setMailMethod('ESS');
      }
    } else {
      setMailMethod('ESS');
    }
  }, [distribution]);

  const mutation = useMutation((method: any) => PaymentsService.postDistributionMethod(method || 'ESS'), {
    onSuccess: () => {
      AlertAdapter(t('distributionModal.onSave'), 'success');
    },
    onError: () => {
      AlertAdapter(t('distributionModal.onError'), 'error');
    },
  });

  return (
    <>
      {/* <MainTitle>{t('personalInfo.workLocation.title')}</MainTitle> */}
      <div>
        <Container
          style={{ boxShadow: '0px 0px 6px #E3E3E3', borderRadius: '5px', display: 'flex', flexDirection: 'column' }}
        >
          <FormTitle>
            <FormTitleItem style={{ fontSize: '23px' }}>Distribution Method</FormTitleItem>
          </FormTitle>
          <SeparatorLineStraight />
          <FormRow>
            <WorkLocationFormContainer>
              <ChoiceContainer>
                <TextChoice style={{ fontWeight: 'bolder' }}>{t('distributionModal.choice')}</TextChoice>
              </ChoiceContainer>
              <CommonDropdown
                label=""
                id="distribution_method_personal"
                name="distribution_method_personal"
                value={mailMethod}
                options={dropdownOptions}
                wrapperStyle={{ width: '100%' }}
                setValue={(value: any) => {
                  setMailMethod(value);
                  mutation.mutate(value);
                }}
                selectStyle={{
                  fontWeight: 'normal',
                  minWidth: '100%',
                  marginLeft: '2%',
                  border: '0.3px rgb(100,100,100) solid',
                }}
              />
            </WorkLocationFormContainer>
          </FormRow>
        </Container>
      </div>
    </>
  );
};

export default DistributionForm;
